import { AddressColumn, BsrsGrid, Column } from '@/components/BsrsGrid'
import React from 'react'
import { useLocalization } from '@/hooks/localization'

const BlacklistReportGridCompanyType = ({ dataSource, sheetHeader }) => {
  const { localize, localizeProps } = useLocalization()

  const companyType = ({ dataItem }) => {
    return dataItem.companyType ? <td>{dataItem.companyType[localizeProps()]}</td> : <td />
  }

  const companyState = ({ dataItem }) => {
    return dataItem.companyState ? <td>{dataItem.companyState[localizeProps()]}</td> : <td />
  }

  const companyTypeExport = ({ dataItem, localizeProps }) => {
    return dataItem.companyType ? dataItem.companyType[localizeProps()] : ''
  }

  const companyStateExport = ({ dataItem, localizeProps }) => {
    return dataItem.companyState ? dataItem.companyState[localizeProps()] : ''
  }

  return <BsrsGrid
    name='cbiIgnoredBlacklists' inputType='grid' readonly
    dataSource={dataSource} sheetHeader={sheetHeader}>
    <Column field='name' title={localize('Common.ArabicName')} />
    <Column field='latinName' title={localize('Common.LatinName')} />
    <Column field='code' title={localize('Common.Code')} />
    {AddressColumn({ dataField: 'address', locale: 'ar', field: 'address', title: localize('Common.ArabicAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'address', locale: 'en', field: 'latinAddress', title: localize('Common.EnglishAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'previousAddress', locale: 'ar', field: 'previousAddress', title: localize('Common.PreviousArabicAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'previousAddress', locale: 'en', field: 'previousLatinAddress', title: localize('Common.PreviousEnglishAddress'), filterable: false, editable: false })}
    <Column field='companyType' cell={companyType} cellExport={companyTypeExport} title={localize('Common.CompanyType')} filterable={false} editable={false} />
    <Column field='companyState' cell={companyState} cellExport={companyStateExport} title={localize('Common.State')} filterable={false} editable={false} />
  </BsrsGrid>
}

export { BlacklistReportGridCompanyType }



// WEBPACK FOOTER //
// ./src/internal-app/pages/blacklistReports/blacklistReportGridCompanyType.js